import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSetup } from '../../hooks/useSetup.ts';
import { INTEGRATIONS_PATH, dismissStale, sourceName, staleDismissed } from '../../lib/setup.ts';

/**
 * "No new rides for N days. Is X still connected?" on the Dashboard when
 * ``stale`` is set. Dismissing hides it for 7 days on this browser.
 */
export function StaleBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data } = useSetup();
  const [hidden, setHidden] = useState(staleDismissed);
  const stale = data?.stale;
  if (!stale || hidden) return null;
  const source = sourceName(stale.source) ?? t('setup.stale.yourDevice');
  return (
    <div className="rounded-xl border border-amber-400/40 bg-amber-400/10 px-4 py-3 flex flex-wrap items-center justify-between gap-2 text-sm">
      <p className="text-(--color-text-primary)">{t('setup.stale.body', { count: stale.days, source })}</p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(INTEGRATIONS_PATH)}
          className="px-3 py-1 rounded-lg text-xs font-semibold bg-amber-400/20 text-amber-200 hover:bg-amber-400/30"
        >
          {t('setup.stale.check')}
        </button>
        <button
          type="button"
          aria-label={t('setup.stale.dismiss')}
          onClick={() => {
            dismissStale();
            setHidden(true);
          }}
          className="text-(--color-text-secondary) hover:text-(--color-text-primary) px-1 text-lg leading-none"
        >
          ×
        </button>
      </div>
    </div>
  );
}
